import { render, staticRenderFns } from "./Gradient.vue?vue&type=template&id=a1e316e8&scoped=true"
import script from "./Gradient.vue?vue&type=script&lang=js"
export * from "./Gradient.vue?vue&type=script&lang=js"
import style0 from "./Gradient.vue?vue&type=style&index=0&id=a1e316e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e316e8",
  null
  
)

export default component.exports